const detectShopifyEditor = () => {
  const el = document.getElementById('shopify-section-footer');
  if (!el) {
    return;
  }

  const attrs = el.attributes;
  let i;

  for (i = attrs.length - 1; i >= 0; i--) {
    if (attrs[i].name.indexOf('data-theme-editor-section') === 0) {
      document.documentElement.classList.add('is-shopify-editor');
    }
  }
};

export default detectShopifyEditor;
